module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Note"
  }, [_c('p', {
    staticClass: "Note-title"
  }, [_vm._v(_vm._s(_vm.note.title))]), _vm._v(" "), _c('p', {
    staticClass: "Note-date"
  }, [_vm._v(_vm._s(_vm.note.created_at))]), _vm._v(" "), (_vm.note.status == 'pending') ? _c('p', {
    staticClass: "Note-status"
  }, [_vm._v("Pending Approval")]) : _vm._e(), _vm._v(" "), (_vm.note.status != 'personal') ? _c('p', {
    staticClass: "Note-author u-mb1"
  }, [_vm._v("Added by " + _vm._s(_vm.note.author_name))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "u-richtext u-richtext--scale u-mt1"
  }, [_c('p', [_vm._v(_vm._s(_vm.note.body))])]), _vm._v(" "), (!!_vm.note.attachments.edges.length) ? _c('ul', {
    staticClass: "AttachmentListing u-mt3"
  }, _vm._l((_vm.note.attachments.edges), function(attachmentNode, index) {
    return _c('li', {
      staticClass: "AttachmentListing-item"
    }, [_c('a', {
      staticClass: "Attachment Button Button--outline",
      attrs: {
        "href": attachmentNode.node.url
      }
    }, [_vm._v("\n        " + _vm._s(attachmentNode.node.filename) + "\n        "), _c('span', {
      staticClass: "Attachment-meta"
    }, [_vm._v(_vm._s(attachmentNode.node.file_size))]), _vm._v(" "), _c('icon', {
      attrs: {
        "icon": "download"
      }
    })], 1)])
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ca8780d2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/vue/components/note.vue
// module id = 348
// module chunks = 0